import { fg } from '@atlassian/jira-feature-gating';

const activityPanelModernisationRelayProvider = {
	get(): boolean {
		return fg('activity_panel_modernisation');
	},
};

export default activityPanelModernisationRelayProvider;
